<div class="lum-c-rfq-details-cost">
  <div class="lum-c-rfq-details-cost__header">
    <h5>Cost Layers</h5>
    <div class="lum-c-rfq-details-cost__header-control">
      <mat-checkbox
        class="lum-c-rfq-details-cost__header-control-checkbox"
        labelPosition="before"
        [ngModel]="showEmptyCostLayers$ | async"
        (ngModelChange)="showEmptyCostLayers = $event"
        >Show Empty Layers</mat-checkbox
      >
    </div>
  </div>
  <lum-cost-layers-basic-table
    [columnDefs]="costLayersColumns"
    domLayout="autoHeight"
    [pageSize]="25"
    [productId]="rfq.id"
    [hideEmptyCostLayers]="(showEmptyCostLayers$ | async) === false"
  ></lum-cost-layers-basic-table>
</div>
